import { theme } from "./theme"

export const globalMixins = {
  container: `
        width: 100%;
        margin: 0 auto;
        padding: 0 32px;
        max-width: ${theme.breakPoints.wide};
        @media (max-width: ${theme.breakPoints.wide}) {
            max-width: ${theme.breakPoints.desktop};
        }
        @media (max-width: ${theme.breakPoints.tablet}) {
            padding: 0 24px;
        }
        @media (max-width: ${theme.breakPoints.mobile}) {
            padding: 0 16px;
        }
    `,
  typography: {
    h1: `
            font-family: ${theme.fonts.bembo};
            font-size: 38px;
            line-height: 1.3;
            color: ${theme.colors.darkGrey};
            margin: 0;
            @media (max-width: ${theme.breakPoints.tablet}){
                font-size: 32px;
            }

            &:after{
                content: "";
                width: 48px;
                height: 1px;
                background: ${theme.colors.darkGrey};
                display: block;
                margin-top: 8px;
                @media (max-width: ${theme.breakPoints.tablet}){
                    width: 32px;
                }
            }
        `,
    heading: `
            font-family: ${theme.fonts.circularMedium};
            font-size: 24px;
            line-height: 1.3;
            color: ${theme.colors.darkGrey};
            margin: 0;
            @media (max-width: ${theme.breakPoints.tablet}){
                font-size: 22px;
            }
        `,
    body: `
            font-family: ${theme.fonts.circularBook};
            font-size: 16px;
            line-height: 1.3;
            color: ${theme.colors.darkGrey80};
            margin: 0;
            @media (max-width: ${theme.breakPoints.tablet}){
                font-size: 14px;
            }
        `,
  },
}
